module.exports = __webpack_public_path__ + "static/media/m-doctors-bg.2fcdf8ca.png";